import React from 'react';
import { Hero } from './components/Hero';
import { StatsStrip } from './components/StatsStrip';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { ForWho } from './components/ForWho';
import { System } from './components/System';
import { Modules } from './components/Modules';
import { Bonuses } from './components/Bonuses';
import { Comparison } from './components/Comparison';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { ClosingCTA } from './components/ClosingCTA';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen flex flex-col w-full font-sans" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <SocialProofPopup data-id="element-2" />
      <Hero data-id="element-3" />
      <StatsStrip data-id="element-4" />
      <Testimonials data-id="element-5" />
      <PainPoints data-id="element-6" />
      <ForWho data-id="element-7" />
      <System data-id="element-8" />
      <Modules data-id="element-9" />
      <Bonuses data-id="element-10" />
      <Comparison data-id="element-11" />
      <Pricing data-id="element-12" />
      <Guarantee data-id="element-13" />
      <FAQ data-id="element-14" />
      <ClosingCTA data-id="element-15" />
      <Footer data-id="element-16" />
    </div>;
}